import { makeStyles } from '@material-ui/core'
import Grid from '@mui/material/Grid'
import {
  Autocomplete,
  FormControl,
  FormControlLabel,
  FormHelperText,
  InputAdornment,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  TextField,
} from '@mui/material'
import React from 'react'
import {
  getFormControlErrorText,
  isFormControlError,
} from 'src/services/formHelperService'
import CustomDatePicker from 'src/components/BuyPolicy/common/CustomDatePicker'
import { GENDER_LIST } from 'src/utils/constants/BuyPolicy'
import IconButton from '@mui/material/IconButton'
import { Clear } from '@mui/icons-material'
import { addScroll, removeScroll } from 'src/utils/commonMethods'
import AddressForm from 'src/components/BuyPolicy/insuranceScreens/life/forms/AddressForm'

const LifeProposerDetailsForm = ({
  lifeMemberDetailsForm,
  providerDetails,
}) => {
  const classes = useStyles()

  const { values } = lifeMemberDetailsForm

  const handleIsPermanentAddressCheck = (event) => {
    const { checked } = event?.target
    lifeMemberDetailsForm.setFieldValue(
      'proposerDetails.address.isCurrentAddressPermanent',
      checked,
      true
    )
  }

  const getIsCurrentAddressPermanent = () => {
    return lifeMemberDetailsForm?.values?.proposerDetails?.address
      ?.isCurrentAddressPermanent
  }
  return (
    <div className={classes.root}>
      <div className={classes.proposerDetailsForm}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6} lg={4}>
            <FormControl fullWidth>
              <TextField
                id='firstName'
                name='proposerDetails.firstName'
                type='text'
                placeholder='First Name *'
                required
                value={values?.proposerDetails?.firstName}
                onChange={lifeMemberDetailsForm.handleChange}
                onBlur={lifeMemberDetailsForm.handleBlur}
                error={isFormControlError(
                  lifeMemberDetailsForm,
                  'proposerDetails.firstName'
                )}
                helperText={getFormControlErrorText(
                  lifeMemberDetailsForm,
                  'proposerDetails.firstName'
                )}
                className={classes.inputTextField}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} md={6} lg={4}>
            <FormControl fullWidth>
              <TextField
                id='lastName'
                name='proposerDetails.lastName'
                type='text'
                placeholder='Last Name *'
                required
                value={values?.proposerDetails?.lastName}
                onChange={lifeMemberDetailsForm.handleChange}
                onBlur={lifeMemberDetailsForm.handleBlur}
                error={isFormControlError(
                  lifeMemberDetailsForm,
                  'proposerDetails.lastName'
                )}
                helperText={getFormControlErrorText(
                  lifeMemberDetailsForm,
                  'proposerDetails.lastName'
                )}
                className={classes.inputTextField}
              ></TextField>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={6} lg={4}>
            <FormControl fullWidth>
              <CustomDatePicker
                id='dateOfBirth'
                name='proposerDetails.dateOfBirth'
                type='date'
                placeholder='Date of birth *'
                value={values?.proposerDetails?.dateOfBirth}
                onChange={lifeMemberDetailsForm.handleChange}
                onBlur={lifeMemberDetailsForm.handleBlur}
                error={isFormControlError(
                  lifeMemberDetailsForm,
                  'proposerDetails.dateOfBirth'
                )}
                helperText={getFormControlErrorText(
                  lifeMemberDetailsForm,
                  'proposerDetails.dateOfBirth'
                )}
                className={classes.inputTextField}
              ></CustomDatePicker>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={6} lg={4}>
            <FormControl fullWidth>
              <RadioGroup
                row
                id='gender'
                name='proposerDetails.gender'
                value={values?.proposerDetails?.gender}
                onChange={lifeMemberDetailsForm.handleChange}
                onBlur={lifeMemberDetailsForm.handleBlur}
                error={isFormControlError(
                  lifeMemberDetailsForm,
                  'proposerDetails.gender'
                )}
                helperText={getFormControlErrorText(
                  lifeMemberDetailsForm,
                  'proposerDetails.gender'
                )}
              >
                {GENDER_LIST?.map((genderListItem) => {
                  return (
                    <FormControlLabel
                      key={`gender_${genderListItem?.label}`}
                      value={genderListItem?.enum}
                      control={<Radio />}
                      label={genderListItem?.label}
                      className={classes.labelList}
                    />
                  )
                })}
              </RadioGroup>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={6} lg={4}>
            <FormControl fullWidth>
              <TextField
                id='height'
                type='number'
                name='proposerDetails.height'
                placeholder='Height *'
                required
                value={values?.proposerDetails?.height}
                onChange={lifeMemberDetailsForm.handleChange}
                onBlur={lifeMemberDetailsForm.handleBlur}
                error={isFormControlError(
                  lifeMemberDetailsForm,
                  'proposerDetails.height'
                )}
                helperText={getFormControlErrorText(
                  lifeMemberDetailsForm,
                  'proposerDetails.height'
                )}
                className={classes.inputTextField}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position='end'>CM</InputAdornment>
                  ),
                }}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} md={6} lg={4}>
            <FormControl fullWidth>
              <TextField
                id='weight'
                type='number'
                name='proposerDetails.weight'
                placeholder='Weight *'
                required
                value={values?.proposerDetails?.weight}
                onChange={lifeMemberDetailsForm.handleChange}
                onBlur={lifeMemberDetailsForm.handleBlur}
                error={isFormControlError(
                  lifeMemberDetailsForm,
                  'proposerDetails.weight'
                )}
                helperText={getFormControlErrorText(
                  lifeMemberDetailsForm,
                  'proposerDetails.weight'
                )}
                className={classes.inputTextField}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position='end'>KG</InputAdornment>
                  ),
                }}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} md={6} lg={4}>
            <FormControl fullWidth>
              <TextField
                id='email'
                name='proposerDetails.email'
                type='email'
                placeholder='Email *'
                required
                value={values?.proposerDetails?.email}
                onChange={lifeMemberDetailsForm.handleChange}
                onBlur={lifeMemberDetailsForm.handleBlur}
                error={isFormControlError(
                  lifeMemberDetailsForm,
                  'proposerDetails.email'
                )}
                helperText={getFormControlErrorText(
                  lifeMemberDetailsForm,
                  'proposerDetails.email'
                )}
                className={classes.inputTextField}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} md={6} lg={4}>
            <FormControl fullWidth>
              <TextField
                id='phone'
                name='proposerDetails.phone'
                type='phone'
                placeholder='Phone *'
                value={values?.proposerDetails?.phone}
                onChange={lifeMemberDetailsForm.handleChange}
                onBlur={lifeMemberDetailsForm.handleBlur}
                error={isFormControlError(
                  lifeMemberDetailsForm,
                  'proposerDetails.phone'
                )}
                helperText={getFormControlErrorText(
                  lifeMemberDetailsForm,
                  'proposerDetails.phone'
                )}
                className={classes.inputTextField}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} md={6} lg={4}>
            <FormControl
              className={classes.formContainerStyles}
              fullWidth
              error={isFormControlError(
                lifeMemberDetailsForm,
                'proposerDetails.profession'
              )}
            >
              <Autocomplete
                id='profession'
                name='proposerDetails.profession'
                value={
                  providerDetails?.occupation?.find(
                    (item) => item.value === values?.proposerDetails?.profession
                  ) || null
                }
                // onChange={(event, newValue) => {
                // handleProposerDetailsChange({
                //   target: { name: 'profession', value: newValue?.value || '' },
                // });
                // }}
                options={providerDetails?.occupation ?? []}
                getOptionLabel={(option) => option?.label}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    id='profession'
                    name='proposerDetails.profession'
                    placeholder='Occupation'
                    className={classes.inputTextField}
                    sx={{
                      '& .MuiInputBase-root': {
                        '& input': {
                          height: '0.7rem !important',
                          minHeight: 'unset',
                        },
                      },
                      '& .MuiInputAdornment-root': {
                        display: values?.proposerDetails?.profession
                          ? ''
                          : 'none',
                      },
                    }}
                    endAdornment={
                      values?.proposerDetails?.profession && (
                        <IconButton
                          id='professionClear'
                          className='clear-button'
                          // onClick={() => handleClear('profession')}
                        >
                          <Clear />
                        </IconButton>
                      )
                    }
                  />
                )}
                renderOption={(props, option) => (
                  <MenuItem {...props} key={option?.value} value={option}>
                    {option?.label}
                  </MenuItem>
                )}
                onOpen={() => {
                  removeScroll()
                }}
                onClose={() => {
                  addScroll()
                }}
              />
              {isFormControlError(
                lifeMemberDetailsForm,
                'proposerDetails.profession'
              ) && (
                <FormHelperText>
                  {getFormControlErrorText(
                    lifeMemberDetailsForm,
                    'proposerDetails.profession'
                  )}
                </FormHelperText>
              )}
            </FormControl>
          </Grid>

          <Grid item xs={12} md={6} lg={4}>
            <FormControl
              className={classes.formContainerStyles}
              fullWidth
              error={isFormControlError(
                lifeMemberDetailsForm,
                'proposerDetails.maritalStatus'
              )}
            >
              <Select
                id='maritalStatus'
                name='proposerDetails.maritalStatus'
                placeholder='Marital Status *'
                displayEmpty
                className={classes.inputTextField}
                value={values?.proposerDetails?.maritalStatus}
                onChange={lifeMemberDetailsForm.handleChange}
                onBlur={lifeMemberDetailsForm.handleBlur}
                error={isFormControlError(
                  lifeMemberDetailsForm,
                  'proposerDetails.maritalStatus'
                )}
                helperText={getFormControlErrorText(
                  lifeMemberDetailsForm,
                  'proposerDetails.maritalStatus'
                )}
                sx={{
                  '&  .MuiSelect-select': {
                    height: '0.7rem !important',
                    minHeight: 'unset',
                  },
                  '& .MuiSelect-iconOutlined': {
                    display: values?.proposerDetails?.maritalStatus
                      ? 'none'
                      : '',
                  },
                }}
                endAdornment={
                  <IconButton
                    id='maritalStatusClear'
                    sx={{
                      display: values?.proposerDetails?.maritalStatus
                        ? ''
                        : 'none',
                    }}
                    className={'clear-button'}
                    // onClick={() => handleClear('maritalStatus')}
                  >
                    <Clear />
                  </IconButton>
                }
                onOpen={() => {
                  removeScroll()
                }}
                onClose={() => {
                  addScroll()
                }}
              >
                <MenuItem value={''} className={'default-menu-item'}>
                  Marital Status
                </MenuItem>
                {providerDetails?.maritalStatus?.map(
                  (maritalStatusListItem) => (
                    <MenuItem
                      value={maritalStatusListItem?.value}
                      key={maritalStatusListItem?.value}
                    >
                      {maritalStatusListItem?.label}
                    </MenuItem>
                  )
                )}
              </Select>
              {isFormControlError(
                lifeMemberDetailsForm,
                'proposerDetails.maritalStatus'
              ) && (
                <FormHelperText>
                  {getFormControlErrorText('proposerDetails.maritalStatus')}
                </FormHelperText>
              )}
            </FormControl>
          </Grid>

          <Grid item xs={12} md={6} lg={4}>
            <FormControl fullWidth>
              <TextField
                id='panNumber'
                name='proposerDetails.panNumber'
                type='text'
                placeholder='PAN Number *'
                required
                value={values?.proposerDetails?.panNumber}
                onChange={lifeMemberDetailsForm.handleChange}
                onBlur={lifeMemberDetailsForm.handleBlur}
                error={isFormControlError(
                  lifeMemberDetailsForm,
                  'proposerDetails.panNumber'
                )}
                helperText={getFormControlErrorText(
                  lifeMemberDetailsForm,
                  'proposerDetails.panNumber'
                )}
                className={classes.inputTextField}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} md={6} lg={4}>
            <FormControl fullWidth>
              <TextField
                id='aadharNumber'
                name='proposerDetails.aadharNumber'
                type='text'
                placeholder='Aadhar Number'
                value={values?.proposerDetails?.aadharNumber}
                onChange={lifeMemberDetailsForm.handleChange}
                onBlur={lifeMemberDetailsForm.handleBlur}
                error={isFormControlError(
                  lifeMemberDetailsForm,
                  'proposerDetails.aadharNumber'
                )}
                helperText={getFormControlErrorText(
                  lifeMemberDetailsForm,
                  'proposerDetails.aadharNumber'
                )}
                className={classes.inputTextField}
                required
              />
            </FormControl>
          </Grid>
        </Grid>
      </div>

      <hr className={classes.separator} />
      <AddressForm
        form={lifeMemberDetailsForm}
        addressLabel='Current Address'
        addressKey='proposerDetails.address.currentAddress'
        isCurrentAddressForm={true}
        handleIsPermanentAddressCheck={handleIsPermanentAddressCheck}
        isCurrentAddressPermanent={getIsCurrentAddressPermanent()}
      />

      {!getIsCurrentAddressPermanent() ? (
        <>
          <hr className={classes.separator} />
          <AddressForm
            form={lifeMemberDetailsForm}
            addressLabel='Permanent Address'
            addressKey='proposerDetails.address.permanentAddress'
          />
        </>
      ) : null}
    </div>
  )
}

export default LifeProposerDetailsForm

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
  },
  inputTextField: {
    borderRadius: '5px !important',
    backgroundColor: 'white !important',
    fontSize: '12px !important',
    fontFamily: 'Roboto !important',
    width: '100%',
    '&  .MuiOutlinedInput-input': {
      height: '0.7rem',
    },
  },
  labelList: {
    '& .MuiFormControlLabel-label': {
      fontSize: '12px',
    },
  },
  separator: {
    margin: 'unset',
    width: '100%',
    borderColor: '#29AACD',
    opacity: '0.2',
  },
  formContainerStyles: {
    margin: 0,
  },
})

// <Grid item xs={12} md={6} lg={4}>
//   <FormControl fullWidth></FormControl>
// </Grid>
